import { FC, useEffect } from 'react';
import { deepCopy, isNotEmpty, isNotEmptyAny } from '@lhb/func';
import { useCurrentUserInfo } from '@/common/hook/useCurrentUserInfo';
import { getUserPageList } from '@/common/api/brief';
import FormSearchUser from '@/common/components/Form/FormSearchUser';

// 不自动赋值的标识
const noInitAssignmentIdentification = [
  'franchiseeAffiliation2',
];
/**
 * 动态表单项-公司成员
 * @description 该组件内部处理，单选多选情况下都统一接收、返回数组格式，如
 * [{ "label": "黄龚伟", "value": 228398, "key": "228398" }, { "label": "13252541454", "value": 221996, "key": "221996" }, { "label": "良辰", "value": 221961, "key": "221961" }]
 */
const Component:FC<{
  form: any;
  propertyItem: any;
  required?: boolean;
  disabled?: boolean;
  /** 编辑状态：true 编辑，false 新增 */
  isEdit?: boolean,
  /** 值变更回调，用于实时更新字段到 tiledFormDataRef.current 的 textValue */
  valueChange?: any,
}> = ({
  form,
  propertyItem,
  required,
  disabled,
  isEdit = false,
  valueChange,
}) => {

  /* state */

  const {
    /* 当前用户信息 */
    currentUserInfo,
  } = useCurrentUserInfo();

  const label = propertyItem.anotherName || propertyItem.name || '';
  const restriction = propertyItem.restriction ? JSON.parse(propertyItem.restriction) : {};
  const placeholder = restriction.placeholder ? restriction.placeholder : `请选择${label}`;
  const rules = [
    { required, message: placeholder },
  ];

  const identification = propertyItem.identification;

  // 单选 single，多选 multiple
  const mode: any = 'single';
  // const mode = 'multiple';

  /* hooks */

  // 新增或编辑时，每次重新渲染动态组件时触发
  useEffect(() => {
    setTimeout(() => { // 避免和 updateValue 同时进行
      // 新增
      if (!isEdit) {
        // 如果不需要初始化赋值
        if (noInitAssignmentIdentification.includes(identification)) return;
        // 新增时赋予默认值
        if (!isNotEmptyAny(form.getFieldValue(identification)) && currentUserInfo && currentUserInfo.id) {
          const _value = [{ value: currentUserInfo.id, label: currentUserInfo.name }];
          form.setFieldValue(identification, _value);
          valueChange?.(identification, deepCopy(_value));
        }
      }
    }, 100);
  }, [propertyItem]);

  /* methods */

  return (<FormSearchUser
    label={label}
    name={identification}
    placeholder={placeholder}
    mode={mode === 'multiple' ? 'multiple' : null}
    // departmentIds={departmentIds}
    maxTagCount={3}
    allowClear={true}
    rules={rules}
    disabled={disabled}
    needCacheSelect
    labelInValue
    selectApi={getUserPageList}
    // onChange={(value: any) => console.log('value', value)}
    formItemConfig={{
      /** 转换 onChange 的值为指定格式 https://ant.design/components/form-cn#formitem */
      getValueFromEvent: (...[val]) => {
        // 将选中项的 value 转换为数组（主要是单选情况）
        return isNotEmpty(val) ? (Array.isArray(val) ? val : [val]).map(item => ({ value: item.value, label: item.label })) : [];
      },
      /** 转换传入的值为 [{ label, value }]，return 的格式一定是 { value: [{ value, label ] } 或 { value: { value, label } } */
      getValueProps: (value: any): any => {
        // 因为该组件保存的值始终为数组格式，所以这里处理单选情况下的值
        const _value = Array.isArray(value) ? value : [];
        if (mode === 'multiple') {
          return { value: _value };
        } else {
          return { value: isNotEmpty(_value) ? (_value.length > 0 ? _value[0] : null) : null };
        }
      }
    }}

  />);
};

export default Component;
